<template>
  <motlet-neo :options="motletOptions">
    <template v-slot:content="{ props }">
      <line-chart :settings="settings" :motlet="props.motlet" :store-name="storeName" :active-increment="activeIncrement" />
    </template>
  </motlet-neo>
</template>

<script>
// import { isEmpty } from 'lodash';
import { getClosest } from '@/utils/datetime';
// BEGIN::Added.by.KWShin.2024.03.29.
import bus from '@/utils/bus';
// FINISH::Added.by.KWShin.2024.03.29.
// BEGIN::Added.by.SHJ.2026.04.29.
import { api } from '@/api/common/instances';
// FINISH::Added.by.SHJ.2026.04.29.
import lineChartable from './duplicationLineChartable';

export default {
  mixins: [lineChartable],
  data() {
    return {
      motletOptions: {
        // id: 'detailview/abap/user/LogonDuplication',
        id: 'dv/abap/user/dup',
        title: 'dv.title.dup',
        monitor: { monitorCode: 'C_ABAP_LOGON_DUP', eventCode: 'LOGON_DUP', points: 120 },
        settings: { chart: { use: true } },
        xAxisPoints: {
          use: true,
          divider: false,
          ready: false,
          value: 120,
          default: 120,
        },
      },
    };
  },
  watch: {
    sstmId: {
      handler() {
        // BEGIN::Modified.by.KWShin.2024.02.29.
        // this.sendMessage();
        if (this.activeIncrement && this.motletOptions.xAxisPoints.ready) this.sendMessage();
        // FINISH::Modified.by.KWShin.2024.02.29.
      },
    },
    activeIncrement: {
      immediate: true,
      handler(value) {
        // BEGIN::Modified.by.KWShin.2024.02.29.
        // if (value) this.sendMessage();
        if (value && this.motletOptions.xAxisPoints.ready) this.sendMessage();
        // FINISH::Modified.by.KWShin.2024.02.29.
      },
    },
  },
  methods: {
    //BEGIN::modified.by.KWShin.2024.03.23.
    /*
    wsBufferedDataHandler(key, responses) {
      const [response] = responses;
      const bound = response.length < this.monitor.points ? response.length : this.monitor.points;
      this.data = response.slice(response.length - bound).map(item => {
        return this.dataHandler(item.data, item.ctime, item.empty);
      });
      this.prepend(['count']);
    },
    wsDataHandler(key, response, ctime, empty) {
      const data = this.dataHandler(response, ctime, empty);
      this.data.push(data);
      this.prepop();
    },
    dataHandler(response, ctime, empty) {
      if (isEmpty(response)) response = [{ stime: ctime }];
      return {
        ctime: parseInt(ctime),
        stime: parseInt(response[0].stime),
        count: empty ? 0 : response.length,
      };
    },
    sendMessage() {
      this.$websocket.realtime.send({
        requests: [
          {
            key: { name: 'rawLogonDup', sstmId: this.sstmId },
            fields: ['stime', 'sstmId'],
            handler: {
              buffer: this.wsBufferedDataHandler,
              every: this.wsDataHandler,
            },
          },
        ],
      });
    },
    prepop() {
      for (; this.monitor.points !== this.data.length; ) {
        this.data.splice(0, 1);
      }
    },
    */
    wsBufferedDataHandler(key, responses) {
      const [response] = responses;
      this.data = response.map(item => {
        return this.dataHandler(item.data, item.ctime);
      });
      // BEGIN::Added.by.SHJ.2026.04.29.
      // WS 버퍼가 monitor.points 만큼 채워지지 않은 경우, 앞쪽 빈 슬롯을 만들어 두고
      // backfillFromDb()에서 DB 데이터로 채울 수 있도록 한다.
      this.prepend(['count']);
      // FINISH::Added.by.SHJ.2026.04.29.
      /*
       * Added.by.KWShin.2024.03.29.
       * 차트에서 MarkLine이 그려질 때 'change:timestamp' 이벤트가 발생되면,
       * 부모 컴포넌트에서 이 이벤트를 받아 그리드와 다이어그램에 timestamp 변경을 통지하는데,
       * markLine은 화면이 시작된 이후 최초의 수집주기가 지나야 그려져서
       * 화면이 진입한 후 최초의 수집주기가 지나기 전까지는 그리드에 데이터 표시도 안되고
       * 다이어그램이 그려지지도 않는다.
       * 따라서, 이 시점에서 'change:timestamp' 이벤트를 발생시켜 주어서 화면 진입 후 즉각적으로
       * 그리드와 다이어그램이 정상적으로 표시될 수 있도록 한다.
       */
      // 데이터 수집이 안되고 있는 시스템이 있을 수 있으므로 this.data의 유무를 체크해야 한다.
      if (this.data && this.data.length > 0) {
        bus.$emit(`change:timestamp-${this.storeName}`, {
          eventCode: this.motletOptions.monitor.eventCode,
          timestamp: this.data[this.data.length - 1].ctime,
        });
      }
      // BEGIN::Added.by.SHJ.2026.04.29.
      // WS 버퍼가 차트 X축 개수(monitor.points)만큼 채우지 못한 경우 앞쪽 빈 구간을 DB에서 보충한다.
      this.backfillFromDb();
      // FINISH::Added.by.SHJ.2026.04.29.
    },
    wsDataHandler(key, response, ctime) {
      const data = this.dataHandler(response, ctime);
      this.data.push(data);
      if (!this.data.length) this.prepop();
    },
    dataHandler(response, ctime) {
      return {
        ctime: parseInt(ctime),
        stime: parseInt(response[0].stime),
        count: parseInt(response[0].cnt),
      };
    },
    // BEGIN::Added.by.SHJ.2026.04.29.
    /**
     * WS 버퍼가 monitor.points 만큼 채워지지 않았을 때 DB(cnt_logon_dup)에서 부족한 앞 구간을 조회해
     * 이미 비어있는 슬롯(count===undefined)에만 값을 주입한다. 실제 WS 데이터는 덮어쓰지 않는다.
     * LogonDuplication은 인스턴스 단위가 아닌 시스템 단위 데이터이므로 첫 번째 결과만 사용한다.
     */
    async backfillFromDb() {
      if (!this.data || this.data.length === 0) return;
      const realPoints = this.data.filter(d => d.count !== undefined && d.count !== '');
      if (realPoints.length === this.data.length) return;
      const beginYmdhms = this.data[0].ctime;
      const endYmdhms = realPoints.length > 0 ? realPoints[0].ctime - this.monitor.cycle : this.data[this.data.length - 1].ctime;
      if (endYmdhms < beginYmdhms) return;
      const params = {
        beginYmdhms,
        endYmdhms,
        sstmId: this.sstmId,
        motletCode: this.monitor.monitorCode,
      };
      try {
        const { data: results } = await api.get('/motlet-data/chart', { params });
        if (!results || results.length === 0) return;
        const [{ data: dbData }] = results;
        if (!dbData) return;
        dbData.forEach(db => {
          const dbCtime = parseInt(db.ctime);
          const slot = this.data.find(p => p.ctime === dbCtime);
          if (slot && (slot.count === undefined || slot.count === '')) {
            slot.count = parseInt(db.count);
            if (db.stime) slot.stime = parseInt(db.stime);
          }
        });
      } catch (e) {
        // DB 조회 실패 시 차트는 WS 실시간 수신으로 점진적으로 채워지므로 무시한다.
        console.warn('[LogonDuplication] backfillFromDb failed', e);
      }
    },
    // FINISH::Added.by.SHJ.2026.04.29.
    /**
     * Added.by.KWShin.20204.03.29.
     * 부모가 X축 길이 설정값을 가져온 뒤 호출해준다.
     * Motlet 메뉴에서 X축 길이 설정이 변경되었을 때에도
     * 편의상 (로직이 동일하므로) 자기 스스로 호출한다.
     */
    xPointsChanged(xPoints) {
      this.motletOptions.xAxisPoints.ready = true;
      this.motletOptions.xAxisPoints.value = xPoints;
      this.motletOptions.monitor.points = xPoints;
      // setXAxisPoints()는 lineChartable.js에 mixins된 motletable.js에 선언된 메소드로 store를 변경시켜준다.
      this.setXAxisPoints(xPoints);
      this.setMonitor(this.motletOptions.monitor);
      /*
       * DB 설정에서 읽어온 xPoints 값을 부모가 전달해주기 전까지는 데이터 구독이 방지되어 있는 상태이므로,
       * 부모에게서 통지가 왔을 때 데이터 구독을 시작한다.
       */
      if (this.activeIncrement) this.sendMessage();
    },
    sendMessage() {
      this.$websocket.realtime.send({
        requests: [
          {
            key: { name: 'cntLogonDup', sstmId: this.sstmId },
            fields: ['stime', 'cnt'],
            // BEGIN::Added.by.KWShin.2024.03.06.
            bufferSize: this.monitor.points,
            // FINISH::Added.by.KWShin.2024.03.06.
            handler: {
              buffer: this.wsBufferedDataHandler,
              every: this.wsDataHandler,
            },
          },
        ],
      });
    },
    prepop() {
      for (; this.data.length > this.monitor.points; ) {
        this.data.splice(0, 1);
      }
    },
    //FINISH::modified.by.KWShin.2024.03.23.
    prepend(fields) {
      for (; this.monitor.points !== this.data.length; ) {
        const timestamp = ((this.data[0] || {}).ctime || getClosest(this.datetime, this.monitor.cycle)) - this.monitor.cycle;
        const addItem = fields.reduce(
          (acc, item) => {
            acc[item] = undefined;
            return acc;
          },
          { ctime: timestamp, stime: timestamp },
        );
        this.data.splice(0, 0, addItem);
      }
    },
  },
  created() {
    /*
      Commmented.by.KWShin.2024.03.29.
      Motlet에 포함된 Settings.vue에서 xAxisPoints에 변동이 생기면 Bus에서 신호가 온다.
      xAxisPoints에 변화가 있으면 차트의 X축의 범위를 변경한다.
    */
    bus.$on(`update:xAxisPoints-${this.motletOptions.id}`, xAxisPoints => {
      /*
       * 실시간인 상태에서 X축 표시범위를 변경하게 되면 차트를 동기화하기가 너무 어렵다.
       * 설정이 변하는 시점에서는 실시간 상태를 꺼준다.
       */
      bus.$emit(`update:activeIncrement`, false);
      this.xPointsChanged(xAxisPoints);
    });
  },
  destroyed() {
    // BEGIN::Added.by.KWShin.2024.03.29.
    bus.$off(`update:xAxisPoints-${this.motletOptions.id}`);
    // FINISH::Added.by.KWShin.2024.03.29.
  },
};
</script>
